import store from '../store'
import { removeId, removeUserName, removeAvatar } from './auth'

export function logout (showBarcode) {
  if (showBarcode) {
    setTimeout(() => {
      store.commit('SET_BARCODESHOW', true)
    }, 1000)
  }
  store.commit('SET_NAME', '')
  store.commit('SET_USERID', '')
  store.commit('SET_AVATAR_URL', '')
  store.commit('SET_LOGIN_STATE', false)
  removeUserName()
  removeAvatar()
  removeId()
}



// WEBPACK FOOTER //
// ./src/utils/logout.js